import { useNavigate } from 'react-router-dom'
import { SystemSettingHashes } from 'src/Libs/navigation/types'
import { useTypedSelector } from 'src/State/RootReducer'

interface ReturnType {
  navigateToSmartChargeDppSettings: () => void
  navigateToSmartChargeBatteryDppSettings: () => void
}

/**
 * This hook provides a function to navigate to the smart charge dpp settings.
 */
const useNavigateToSmartChargeDppSettings = (): ReturnType => {
  const navigate = useNavigate()
  const installationId = useTypedSelector(store => store.storage.activeInstallation)
  const storageId = useTypedSelector(store => store.storage.activeStorage)

  const navigateToSmartChargeDppSettings = (): void => {
    const settingsLink = `/installation/${installationId}/${storageId}/properties/tariffs/${SystemSettingHashes.DynamicPowerPriceSettings}`

    setTimeout(() => navigate(settingsLink, { state: { redirectedFromDppWidget: true } }), 15)
  }

  const navigateToSmartChargeBatteryDppSettings = (): void => {
    const batterySettingsLink = `/installation/${installationId}/${storageId}/properties/tariffs/${SystemSettingHashes.DynamicPowerPriceSettingsBattery}`

    setTimeout(() => navigate(batterySettingsLink, { state: { redirectedFromDashboard: true } }), 15)
  }

  return { navigateToSmartChargeDppSettings, navigateToSmartChargeBatteryDppSettings }
}

export default useNavigateToSmartChargeDppSettings
